import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Textarea } from '@/components/ui/textarea'
import { Label } from '@/components/ui/label'
import { Award, Star } from 'lucide-react'
import type { UseFormRegister } from 'react-hook-form'
import type { RegistrationFormData } from '@/lib/types/registration'

interface SportsExpertiseSectionProps {
  register: UseFormRegister<RegistrationFormData>
}

export function SportsExpertiseSection({ register }: SportsExpertiseSectionProps) {
  return (
    <Card variant="premium">
      <CardHeader className="pb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
            <Award className="w-5 h-5 text-primary" />
          </div>
          <div>
            <CardTitle>Sports Expertise</CardTitle>
            <p className="text-sm text-slate-500 mt-0.5">Optional - Tell us about your experience</p>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div>
          <Label htmlFor="sportsExpertise" className="flex items-center gap-2 mb-2">
            <Star className="w-4 h-4 text-slate-400" />
            Your Sports Background
          </Label>
          <Textarea
            id="sportsExpertise"
            {...register('sportsExpertise')}
            placeholder="Tell us about your sports experience, achievements, or any special skills..."
            rows={4}
            className="resize-y"
          />
        </div>
      </CardContent>
    </Card>
  )
}
